<template lang="pug">
  v-dialog(v-model="dialog" width=500)
    v-card
      v-card-text
        v-layout(row, wrap)
          v-flex(xs12)
            v-text-field.mx-4(
              label="Procurar"
              v-model="search"
              append-icon="search"
            )
            v-treeview(
              :items='itemsFormated'
              :search='search'
              :open.sync='open'
              v-model='itemsSelecteds'
              :selectable='true')
              template(v-slot:label='{ item }')
                v-img.grey.lighten-2.my-2(v-if="item.type === 'image'", width='350', :src='item.url')
                  template(v-slot:placeholder='')
                    v-layout(fill-height align-center justify-center ma-0)
                      v-progress-circular(indeterminate color="grey lighten-5")
                template(v-else='')
                  | {{ item.name | uppercase }}
      v-card-actions
        v-btn(color="primary" outline @click="savePresets") Salvar parametros
        v-spacer
        v-btn(@click="$emit('input', false)") cancelar
        v-btn(color="primary" @click="save") aplicar
</template>

<script>
  import apiUser from '@/api/user'
  import { mapState } from 'vuex'
  import axios from 'axios'

  const URL_BASE_IMAGE = 'https://app.ultrahealth.care/functions/healthcareImage?id='
  export default {
    name: 'dialogPresetPrint',

    props: {
      value: {
        type: Boolean,
        required: true
      },
      id: {
        type: String
      },
      reportType: {
        type: String
      }
    },

    computed: {
      ...mapState({
        gi: (state) => state.ultraFetal.gestationInteraction,
        user: (state) => state.user
      }),
      itemsFormated () {
        if (this.items.length === 0) return
        this.mapGroupById = {}

        let items = []

        items.push({
          id: 'report.header',
          name: 'Cabeçalho'
        })
        this.mapGroupById['report.header'] = 'report.header'

        this.items.forms.forEach((item, index) => {
          if (index > 0) {
            let lastItem = items[items.length - 1]
            if (lastItem.name === item.form) {
              lastItem.children = [
                ...lastItem.children,
                this.mountItem(item).children[0]
              ]
              return
            }
          }
          if (this.reportType !== 'General' || item.order <= 1) items.push(this.mountItem(item))
        })

        if (this.items.charts) {
          let graficoItems = {
            id: 'graficos',
            key: 'graficos',
            name: 'Gráficos',
            children: []
          }
          this.mapGroupById['graficos'] = 'graficos'
          this.items.charts.forEach((item, index) => {
            const { key } = item
            graficoItems.children.push({
              id: key,
              key: key,
              name: item.comp
            })
            this.mapGroupById[key] = 'graficos'
          })

          if (this.reportType !== 'General') items.push(graficoItems)
        }

        if (this.items.conclusion) {
          items.push({
            id: 'conclusion.info.text',
            key: 'conclusion.info.text',
            name: 'conclusão'
          })
          this.mapGroupById['conclusion.info.text'] = 'conclusion.info.text'
        }

        if (this.items.images) {
          let imageItems = {
            id: 'images',
            key: 'images',
            name: 'Imagens',
            children: []
          }
          this.items.images.forEach((item, index) => {
            const id = 'image.id.' + item
            imageItems.children.push({
              id: id,
              key: id,
              name: id,
              url: URL_BASE_IMAGE + item,
              type: 'image'
            })
          })

          items.push(imageItems)
          this.mapGroupById['images'] = 'images'
        }

        return items
      }
    },

    watch: {
      value (val) {
        this.dialog = val
      },
      dialog (val) {
        this.$emit('input', val)
      },
      gi () {
        if (this.gi.iuid) {
          this.init()
        }
      }
    },

    data () {
      return {
        dialog: false,
        items: [],
        open: [1],
        search: null,
        itemsSelecteds: [],
        mapGroupById: {},
        hasPreset: false
      }
    },

    mounted () {
      this.init()
    },

    methods: {
      async init () {
        if (!this.gi.iuid) await this.$store.dispatch('ultraFetal/getGestationInteraction', this.id)
        await this.load()
        this.loadPreset()
      },
      async load () {
        await axios.get(`https://app.ultrahealth.care/functions/reportPrint?id=${this.gi.iuid}&ignoreFilter=true`)
          .then(res => {
            this.items = res.data
            if (this.gi.print && this.gi.print.length > 0) {
              this.itemsSelecteds = this.gi.print
            }
            this.loaded = true
          })
      },
      async loadPreset () {
        const preset = await apiUser.printPresets.getGI(this.user.uid)
        if (!preset) return
        if (this.gi.print && this.gi.print.length > 0) return

        this.itemsSelecteds = Object.entries(preset).reduce((accumulator, [key, values]) => {
          if (key === 'iuid') return accumulator
          accumulator = accumulator.concat(values)
          return accumulator
        }, [])
      },
      async save () {
        const items = this.itemsSelecteds.filter(item => item.indexOf('.') > -1)
        if (this.reportType === 'General') items.push('conclusion.info.text')
        if (!this.loaded) return
        await this.$store.dispatch('ultraFetal/setGestationInteractionPrint', items)
        this.dialog = false
        this.$emit('apply', items)
      },
      async savePresets () {
        const preset = this.formatPreset()
        await apiUser.printPresets.saveGI(this.user.uid, preset)
        this.$awn.success('Parametros foram salvos')
      },
      mountItem (item) {
        let customItem = {
          id: item.key || item.form,
          name: item.comp || item.form,
          group: item.form || item.group,
          children: []
        }

        const { panel } = item
        if (panel) {
          let itemFilter = []
          let uniqueItems = item.items.filter(innerItem => {
            if (!itemFilter.some(item => item.key === innerItem.key)) {
              itemFilter.push({
                ...innerItem,
                group: customItem.group
              })
              return innerItem
            }
          })
          const children = {
            id: panel + customItem.id + item.tab,
            group: customItem.group,
            name: panel.toLowerCase() === 'paciente' ? 'Dados' : (panel + ' ' + item.tab),
            children: [
              ...uniqueItems.map(innerItem => this.mountItem({
                ...innerItem,
                group: customItem.group
              }))
            ]
          }
          customItem.children = [children]
          this.mapGroupById[children.id] = children.group
        } else if (item.items) {
          customItem.children = item.items.map(innerItem => this.mountItem({
            ...innerItem,
            group: customItem.group
          }))
        }

        this.mapGroupById[customItem.id] = customItem.group

        return customItem
      },
      mountItemPreset () {
        // let items = {}
        let itemsGroup = {}
        let group = null
        this.itemsSelecteds.forEach(item => {
          group = this.mapGroupById[item]
          // items[item] = group
          if (group) {
            if (!itemsGroup[group]) itemsGroup[group] = []

            itemsGroup[group].push(item)
          }
        })
        return itemsGroup
      },
      formatPreset () {
        const preset = this.mountItemPreset()
        for (let item in this.itemsFormated) {
          this.hasPreset = false
          for (let selected in preset) {
            if (this.itemsFormated[item].id === selected) {
              this.hasPreset = true
            }
          }
          if (this.hasPreset === false) {
            preset[this.itemsFormated[item].id] = null
          }
        }
        return preset
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/summary/components/dialogPresetPrint.vue